import * as Sentry from '@sentry/browser'
import { AUTH_KEY, FREE_TRIAL_BANNER_DISMISSED_KEY } from 'app-constants'
import { clearMasqueradeToken, markLoggedOut } from 'helpers/auth'
import { safeLocalStorage } from 'helpers/localStorage'
import { saveCurrentUrlForRedirect } from 'helpers/redirect'
import { SIGN_IN } from 'routes'

/**
 * End a session the API rejected: latch the logged-out state so no in-flight response writes it back,
 * drop the stored session and send the page to sign in, remembering where it was. A page already on
 * sign in stays put: reloading it would only repeat the request that was rejected.
 */
export const endRejectedSession = (navigate: (url: string) => void = loadPage): void => {
  markLoggedOut()
  safeLocalStorage.removeItem(AUTH_KEY)
  safeLocalStorage.removeItem(FREE_TRIAL_BANNER_DISMISSED_KEY)
  clearMasqueradeToken()
  Sentry.setUser(null)
  if (window.location.pathname === SIGN_IN) return
  saveCurrentUrlForRedirect()
  navigate(`${SIGN_IN}?reason=sessionExpired`)
}

// A full page load, not a router navigation, so nothing from the ended session survives in memory.
const loadPage = (url: string): void => {
  window.location.href = url
}
